/**
 * Backend stamps `rotationYDeg` on rotated module/composition instances.
 * three.js Y is up and the backend math is a right-handed Y rotation, so the
 * visual rotation is the negated radians. Near-zero angles return 0.
 */
export function moduleYawRadians(rotationYDeg: number | undefined | null): number {
  const deg = Number(rotationYDeg ?? 0);
  if (!Number.isFinite(deg) || Math.abs(deg) <= 1e-6) return 0;
  return -((deg * Math.PI) / 180);
}
